import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpRequestInterceptorModule } from './core/interceptors/request-interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { PipesModule } from './core/pipes/pipes.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DatePipe } from '@angular/common';

@NgModule({ declarations: [
    AppComponent
  ],
    bootstrap: [AppComponent], 
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpRequestInterceptorModule,
    BrowserAnimationsModule,
    NgHttpLoaderModule.forRoot(),
    PipesModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
],
 providers: [
    DatePipe,
provideHttpClient(withInterceptorsFromDi())
]
})
export class AppModule { }
